import { Link } from '@/atoms';
import { ChevronDown, Tick } from '@/icons';
import { Filter } from '@/lib/filters';
import { Label, Listbox, ListboxButton, ListboxOption, ListboxOptions } from '@headlessui/react';

interface FilterListProps {
    filters: Filter[];
    handleSubmit: (number, selectedFilters) => void;
    selectedFilters: any[];
    isLoading: boolean;
}

const FilterList = ({ filters, handleSubmit, selectedFilters, isLoading }: FilterListProps) => (
    <div className='flex flex-wrap gap-8 w-full h-auto justify-start items-center text-body--m text-body py-8 sm:py-4'>
        {filters.map((filter, index) => (
            <Listbox
                key={`filter-${index}`}
                value={selectedFilters[filter.name] || null}
                onChange={(value) => {
                    if (selectedFilters[filter.name] === value) {
                        delete selectedFilters[filter.name];
                    } else {
                        selectedFilters[filter.name] = value;
                    }
                    handleSubmit(0, selectedFilters);
                }}
                disabled={isLoading}
            >
                <div className={`relative w-full sm:w-fit ${isLoading ? 'opacity-50' : ''}`}>
                    <ListboxButton
                        className="w-full sm:w-48 cursor-default rounded-lg bg-white text-primary-500 p-2 text-left shadow-md focus:outline-none focus-visible:border-indigo-500 focus-visible:ring-2 focus-visible:ring-white/75 focus-visible:ring-offset-2 focus-visible:ring-offset-orange-300 sm:text-sm flex justify-between hover:cursor-pointer"
                    >
                        {({ open }) => (
                            <>
                                <Label className={`absolute left-2 ${selectedFilters[filter.name] ? " bottom-full pb-1 font-bold" : "bottom-2"} duration-300 transform`}>
                                    {filter.label}
                                </Label>
                                {selectedFilters[filter.name] ?
                                    filter.list.find((item) => item.value === selectedFilters[filter.name])?.key
                                    :
                                    null
                                }
                                < ChevronDown className={`h-5 w-5 ml-auto ${open ? 'rotate-180' : ''} transform duration-300`} />
                            </>
                        )}
                    </ListboxButton>
                    <ListboxOptions transition className="absolute z-10 w-full overflow-hidden mt-2 rounded-md bg-white text-base shadow-lg ring-1 ring-primary-500/5 focus:outline-none sm:text-sm hover:cursor-pointer transition duration-300 ease-in data-[closed]:opacity-0">
                        {filter.list.map((item) => (
                            <ListboxOption
                                className={({ active }) =>
                                    `flex gap-4 p-2 ${active ? 'bg-primary-500 text-white' : 'text-primary-500'
                                    }`
                                }
                                key={`filter-item-${index}-${item.key}`} value={item.value}
                            >
                                {({ selected, active }) => (
                                    <div className='flex justify-between w-full'>
                                        {item.key}
                                        {selected &&
                                            <Tick className={`w-5 h-5 ${active ? 'text-white' : 'text-primary-500'}`} />}
                                    </div>
                                )}
                            </ListboxOption>
                        ))}
                    </ListboxOptions>
                </div>
            </Listbox>
        ))
        }
        <Link as="button" onClick={() => handleSubmit(0, [])} className="lg:ml-auto cursor-pointer" disabled={isLoading} disableComponent={isLoading}>
            Limpiar filtros
        </Link>
    </div >
);

export default FilterList;
